import React from 'react'

import { cn } from '@/lib/utils'

import { StylesProps } from '../page-header.types'
import { HeaderBanner } from '../shared/header-banner'
import { HeaderDescription } from '../shared/header-description'
import { HeaderLogo } from '../shared/header-logo'
import { HeaderName } from '../shared/header-name'
import { HeaderSocialIcons } from '../shared/header-social-icons'

export const GeexNailSalonPageHeader = ({
  page,
  hasLogoImage,
  hasBannerImage,
  hasName,
  hasDescription,
  forceMobile,
  ...props
}: StylesProps) => {
  return (
    <>
      <div
        className={cn('px-fluid-4 pt-fluid-4', {
          'lg:pt-fluid-14': !forceMobile,
        })}
      >
        <div className="relative text-page-text">
          <div
            className={cn('relative', {
              'pt-fluid-24': !hasBannerImage,
            })}
          >
            <HeaderBanner
              media={page?.bannerMedia}
              className="h-fluid-96 w-full rounded-[40px]"
              {...props}
              style={
                hasLogoImage
                  ? {
                      maskImage: `linear-gradient(black, black),url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTU3IiBoZWlnaHQ9IjE1NyIgdmlld0JveD0iMCAwIDE1NyAxNTciIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMCAwLjQ4NzU3OVYxNTYuNTEySDE1Ni41QzEzNC40MDkgMTU2LjUxMiAxMTYuNSAxMzkuMDQ4IDExNi41IDExNy41MDZWNzguNUMxMTYuNSA1Ni45NTc1IDk4LjU5MTQgMzkuNDkzOCA3Ni41IDM5LjQ5MzhINDBDMTcuOTA4NiAzOS40OTM4IDAgMjIuMDMwMSAwIDAuNDg3NTc5WiIgZmlsbD0iYmxhY2siLz48L3N2Zz4=')`,
                      maskRepeat: 'no-repeat',
                      maskPosition: '-1px calc(100% + 1px)',
                      maskComposite: 'exclude',
                      WebkitMaskImage: `linear-gradient(black, black),url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTU3IiBoZWlnaHQ9IjE1NyIgdmlld0JveD0iMCAwIDE1NyAxNTciIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMCAwLjQ4NzU3OVYxNTYuNTEySDE1Ni41QzEzNC40MDkgMTU2LjUxMiAxMTYuNSAxMzkuMDQ4IDExNi41IDExNy41MDZWNzguNUMxMTYuNSA1Ni45NTc1IDk4LjU5MTQgMzkuNDkzOCA3Ni41IDM5LjQ5MzhINDBDMTcuOTA4NiAzOS40OTM4IDAgMjIuMDMwMSAwIDAuNDg3NTc5WiIgZmlsbD0iYmxhY2siLz48L3N2Zz4=')`,
                      WebkitMaskRepeat: 'no-repeat',
                      WebkitMaskPosition: '-1px calc(100% + 1px)',
                      WebkitMaskComposite: 'exclude',
                    }
                  : undefined
              }
            />

            <HeaderLogo
              media={page?.logoMedia}
              {...props}
              className="absolute bottom-0 left-0 rounded-[30px]"
              sizeClassName="size-[100px]"
              size={100}
            />
          </div>
        </div>
      </div>

      {hasDescription || hasName ? (
        <div className="p-fluid-4">
          <div className="ft-widget page-header-block ft-widget-wrapper p-block flex flex-col space-y-fluid-2">
            <HeaderName
              name={page?.name}
              {...props}
              className="text-fluid-3xl text-page-heading-text"
            />

            <HeaderDescription
              description={page?.description}
              {...props}
              className="text-fluid-base"
            />
          </div>
        </div>
      ) : (
        <div className="pb-fluid-4" />
      )}

      <div className="px-fluid-4 pb-fluid-4">
        <HeaderSocialIcons
          socialIcons={page?.socialIcons}
          {...props}
          className="page-header-block ft-widget-wrapper justify-center rounded-page-widget p-fluid-2 pb-fluid-0"
          primaryClassName="p-fluid-4 page-header-primary-button flex-1 rounded-page-widget-2!"
          secondaryClassName="p-fluid-4 page-header-secondary-button rounded-page-widget-2!"
          showPrimaryLabel
        />
      </div>
    </>
  )
}
